import { useEffect, useRef, useState } from 'react';
import ky from 'ky-universal';

const methods = ['get', 'post', 'put', 'patch', 'head', 'delete'];

/*
 * Generates a new set of hooks for rest API requests
 * @returns {useGet: {function}, usePost: {function}, usePut: {function}, usePatch: {function}, useHead: {function}, useDelete: {function}}
 * */
export default function connectService(domain) {
	const funcGenerator = (acc, method) => {
		acc['use' + capitalise(method)] = function useRequest(defaultPath) {
			const unmounted = useRef(false);
			const [res, setRes] = useState({
				data: {},
				error: false,
				loading: undefined,
				status: undefined
			});

			useEffect(() => {
				return () => {
					unmounted.current = true;
				};
			}, []);

			return [
				res,
				(options, path) => {
					let status;
					setRes({
						data: {},
						error: false,
						loading: true,
						status: undefined
					});

					ky[method](domain + (defaultPath || path), { retry: 2, throwHttpErrors: false, ...options })
						.then(res => {
							status = res.status;
							return res.text();
						})
						.then(data => {
							if (!unmounted.current) {
								setRes({
									data: parseData(data),
									status,
									error: getErrorFromStatus(status),
									loading: false
								});
							}
						})
						.catch(data => {
							if (!unmounted.current) {
								setRes({
									data: { ...data },
									status,
									error: 'An error has occured. Please try again later.',
									loading: false
								});
								throw Error(data);
							}
						});
				}
			];
		};

		return acc;
	};

	return methods.reduce(funcGenerator, {});
}

const capitalise = (string = '') => {
	return string.charAt(0).toUpperCase() + string.substring(1);
};

const parseData = data => {
	if (!data) return true;
	try {
		return JSON.parse(data);
	} catch {
		return true;
	}
};

const getErrorFromStatus = status => {
	switch (status) {
		case 500:
			return 'Server error.';
		default:
			return false;
	}
};
